<script>
  import { createClient, addWebsite, updateClient } from '../api.js';
  import { currentUser } from '../utils.js';
  import { Checkbox, notifications, NotificationDisplay } from '@shopboxai/sb-portal-components';
  let newClient = {
    id: '',
    name: '',
    features: {
      grid_builder: false,
      open_api: false,
      widget_customization: false,
    },
  };

  let newWebsite = {
    name: '',
    attr: '',
    client_id: '',
  };
  let updateClientInfo = {
    name: $currentUser.clientName,
    features: {
      grid_builder: $currentUser.clientFeatures.grid_builder,
      open_api: $currentUser.clientFeatures.open_api,
      widget_customization: $currentUser.clientFeatures.widget_customization,
    },
  };

  let create = async () => {
    try {
      let res = await createClient(newClient);
      newClient = {
        id: '',
        name: '',
        features: {
          grid_builder: false,
          open_api: false,
          widget_customization: false,
        },
      };
      notifications.success('Client created successfully', 2000);
    } catch (error) {
      notifications.danger(`${error}`, 2000);
    }
  };
  let add = async () => {
    try {
      let res = await addWebsite(newWebsite);
      newWebsite = {
        name: '',
        attr: '',
        client_id: '',
      };
      notifications.success('Website added successfully', 2000);
    } catch (error) {
      notifications.danger(`${error}`, 2000);
    }
  };

  let update = async () => {
    try {
      let res = await updateClient(updateClientInfo, $currentUser.clientId);
      notifications.success('User updated successfully', 2000);
    } catch (error) {
      notifications.danger(`${error}`, 2000);
    }
  };
</script>

<main>
  <section class="form-wrapper">
    <form action="" on:submit|preventDefault={create}>
      <div>
        <h2>Add existing client</h2>
        <label for="">Client ID</label>
        <input type="text" placeholder="Enter client id" bind:value={newClient.id} />
        <label for="">Client Name</label>
        <input type="text" placeholder="Enter client name" bind:value={newClient.name} />
        <Checkbox labelText="Grid Builder" bind:value={newClient.features.grid_builder} />
        <Checkbox labelText="Open Api" bind:value={newClient.features.open_api} />
        <Checkbox labelText="Widget Customization" bind:value={newClient.features.widget_customization} />
      </div>

      <button class="primary">Add client</button>
    </form>
    <form action="" on:submit|preventDefault={add}>
      <div>
        <h2>Add website</h2>
        <label for="">Client Name</label>
        <input type="text" placeholder="Enter client name" bind:value={newWebsite.name} />
        <label for="">Client Locale</label>
        <input type="text" placeholder="Enter client locale" bind:value={newWebsite.attr} />
        <label for="">Client ID</label>
        <input type="text" placeholder="Enter client id" bind:value={newWebsite.client_id} />
      </div>

      <button class="primary">Add website</button>
    </form>
    <form action="" on:submit|preventDefault={update}>
      <div>
        <h2>Update current client</h2>
        <label for="">Edit client name</label>
        <input type="text" bind:value={updateClientInfo.name} />
        <h4>Edit client features</h4>
        {#each Object.entries(updateClientInfo.features) as [key, val]}
          <Checkbox labelText={key.split('_').join(' ')} bind:value={updateClientInfo.features[key]} />
        {/each}
      </div>

      <button class="primary">Update</button>
    </form>
  </section>
  <NotificationDisplay />
</main>

<style>h2{font-family:Chivo,serif;margin-bottom:1em}h4{margin-bottom:.5em}main{margin:0 auto;width:100%}.form-wrapper{flex-wrap:wrap}.form-wrapper,form{display:flex;justify-content:space-between}form{align-items:flex-start;flex-basis:45%;flex-direction:column;margin-bottom:1.5em}form>div{width:100%}label{color:var(--t-c);display:inline-block}input[type=text]{border:2px solid var(--brd-l);border-radius:5px;color:var(--t-c-lx);display:block;font-size:15px;line-height:1.5;margin-bottom:1em;padding:16px 20px;width:100%}@media (max-width:750px){.form-wrapper{flex-direction:column}}</style>
